var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',[_c('event-navbar',{attrs:{"title":"Aussteller"}}),_c('v-runtime-template',{attrs:{"template":_vm.header_content}}),_c('div',{staticClass:"container-fluid"},[_c('exhibitor-list',{attrs:{"event-short-name":_vm.$route.params.shortName}})],1),_c('v-runtime-template',{attrs:{"template":_vm.footer_content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }